const changes = [
  {
    "type": "feature",
    "description": "Added a language selector to the lock screen.\n"
  },
  {
    "type": "feature",
    "description": "Added settings to change the line width by settings the expected balance maximum.\n"
  },
  {
    "type": "feature",
    "description": "Added a button to quickly scroll to the current day on chart.\n"
  },
  {
    "type": "feature",
    "description": "Now you can enter values in the input field by pressing Enter.\n"
  },
  {
    "type": "feature",
    "description": "Sidebar menu added with export/import and user settings.\n\nNow you can change language, time zone, currency, and adjust maximum expected volume of asset value to change chart width..\n"
  },
  {
    "type": "feature",
    "description": "Implemented a total spent display for day.\n\nNow you can see the total spent at the bottom of the right side of the chart.\n\nRemaining balance is now displayed at the left bottom side of the chart.\n"
  }
];

export default changes;
